const useThrottleCallback = (callback, delay) => {
  let inProgress = false;
  return (...args) => {
    if (inProgress) {
      return;
    }
    inProgress = true;
    setTimeout(() => {
      callback(...args);
      inProgress = false;
    }, delay);
  };
};

export default useThrottleCallback;
